module.exports = __webpack_public_path__ + "static/media/30-15.57586e6a.mp3";